/* eslint-disable react/prop-types, react/jsx-first-prop-new-line, react/jsx-closing-bracket-location */
import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import assetPath from 'es6/services/asset-path';

export default function LoadingBox({ height }) {
  return (
    <div className={css(styles.loadingBox)}
      style={{ minHeight: height }}>
    </div>
  );
}

const styles = StyleSheet.create({
  loadingBox: {
    backgroundImage: `url('${assetPath('common/loader-32.gif')}')`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
});
